// extracted by mini-css-extract-plugin
export var brand = "_2r-9";
export var button = "_2r-0";
export var chevron = "_2r-v";
export var chevronButton = "_2r-w";
export var content = "_2r-n";
export var danger = "_2r-g";
export var dangerOutlined = "_2r-h";
export var dark = "_2r-l";
export var darkTheme = "_2r-c";
export var extraSmall = "_2r-4";
export var fullWidth = "_2r-8";
export var ghost = "_2r-d";
export var gray = "_2r-t";
export var icon = "_2r-p";
export var iconButton = "_2r-s";
export var iconButtonBorder = "_2r-x";
export var iconButtonBorderDark = "_2r-y";
export var iconButtonBorderLight = "_2r-z";
export var iconLeft = "_2r-q";
export var iconRight = "_2r-r";
export var large = "_2r-1";
export var light = "_2r-m";
export var medium = "_2r-2";
export var micro = "_2r-5";
export var nano = "_2r-7";
export var outlined = "_2r-k";
export var pending = "_2r-a";
export var primary = "_2r-i";
export var shadow = "_2r-o";
export var small = "_2r-3";
export var solidLight = "_2r-e";
export var solidLightBrand = "_2r-f";
export var spinner = "_2r-u";
export var transparent = "_2r-j";
export var warning = "_2r-b";
export var wideNano = "_2r-6";